import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      paddingLeft: theme.spacing(2),
    },
    content: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    margin: {
      margin: 10,
    },
  })
);
